var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m1.667 14.333 3.7-1.422c.236-.091.354-.137.465-.196q.147-.08.28-.183c.1-.077.189-.166.368-.345L14 4.667A1.886 1.886 0 1 0 11.333 2l-7.52 7.52c-.179.18-.268.269-.345.368q-.103.133-.183.28c-.059.11-.104.23-.195.466zm0 0 1.372-3.567c.098-.255.147-.383.231-.441a.33.33 0 0 1 .253-.054c.1.02.197.116.39.31l1.507 1.505c.193.194.29.29.309.391a.33.33 0 0 1-.054.253c-.058.084-.186.133-.441.231z"
  })));
};
export default SvgPencil;